<template>
  <v-container id="reference-term-list">
    <v-row>
      <v-col cols="12" md="12" class="breadcrumbs">
        <v-breadcrumbs :items="breadcrumbs" :large="true" :divider="'>'">
        </v-breadcrumbs>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="8" offset-sm="4">
        <div class="text-right">
          <div cols="10" md="1">
            <app-modal-import-solution
              :color="'success'"
              :icon="'mdi-plus-circle'"
              @onSave="load"
            >
              <template v-slot:title>
                Importação de {{ isAT ? "Iniciativa" : "Solução" }}
              </template>
            </app-modal-import-solution>
            <app-modal-insert-solution
              :edit="false"
              :color="'success'"
              :icon="'mdi-plus-circle'"
              @onSave="load"
              :allSolutions="solutions"
              :municipioSolucao="municipioSolucaoPT"
              :filter="filter"
              v-if="filter.municipioGrupoSolucao"
            >
              <template v-slot:title>
                Cadastramento {{ isAT ? "Iniciativa" : "Solução" }}
              </template>
            </app-modal-insert-solution>
          </div>
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-data-table
          :headers="headers"
          :items="enabledSolutions"
          item-key="name"
          class="elevation-1"
          :footer-props="{ itemsPerPageText: 'Itens por página' }"
        >
          <template v-slot:footer.page-text="items">
            {{ items.pageStart }} - {{ items.pageStop }} de
            {{ items.itemsLength }}
          </template>
          <template v-slot:item="props">
            <tr
              :class="{
                evidenciada: props.item.concluida,
                evidenciar: props.item.interrompida,
              }"
            >
              <td :title="props.item.nome">
                {{ formatTableValues(props.item.nome) }}
              </td>
              <td :title="props.item.descricao">
                {{ formatTableValues(props.item.descricao) }}
              </td>
              <td
                :title="props.item.municipioGrupoSolucao.nome"
                v-if="props.item.municipioGrupoSolucao"
              >
                {{ formatTableValues(props.item.municipioGrupoSolucao.nome) }}
              </td>
              <td>
                <span
                  v-if="props.item.usuario"
                  :title="props.item.usuario.nome"
                >
                  {{ formatTableValues(props.item.usuario.nome) }}
                </span>
              </td>

              <td>
                <v-textarea
                  v-model="props.item.justificativa"
                  :readonly="props.item.concluida || props.item.interrompida"
                ></v-textarea>
              </td>

              <td>
                <app-modal-insert-solution
                  :object="props.item"
                  :edit="true"
                  :color="'warning'"
                  :icon="'mdi-pencil'"
                  :filter="filter"
                  @onSave="load"
                >
                  <template v-slot:title>
                    Edição de {{ isAT ? "Iniciativa" : "Solução" }}
                  </template>
                </app-modal-insert-solution>
              </td>
              <td>
                <app-modal-delete-solution
                  :payload="props.item"
                  v-if="!props.item.concluida && !props.item.interrompida"
                  @onSave="load"
                ></app-modal-delete-solution>
              </td>
              <td>
                <app-modal-confirm-stop-solution
                  :solution="props.item"
                  v-if="!props.item.concluida && !props.item.interrompida"
                  @onCloseModal="load"
                >
                  <template v-slot:title>
                    Interromper {{ isAT ? "Iniciativa" : "Solução" }}
                  </template>
                </app-modal-confirm-stop-solution>
              </td>
            </tr>
          </template>

          <template slot="no-data">
            <div class="progress" v-if="loading">
              <v-progress-circular
                indeterminate
                color="primary"
              ></v-progress-circular>
            </div>

            <div v-else>
              Nenhuma {{ isAT ? "Iniciativa" : "Solução" }} retornada
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <AppRetrieveSolution
          :solutions="disabledSolutions"
          @onRecover="load"
        ></AppRetrieveSolution>
      </v-col>
    </v-row>

    <app-modal-confirm-finish-solution
      :dialog="modalConfirmFinishSolution"
      :solutions="solutionsToFinish"
      @onCloseModal="closeModalFinish()"
    >
    </app-modal-confirm-finish-solution>
  </v-container>
</template>

<script>
import AppModalInsertSolution from "@/modules/solution/components/city/ModalInsert";
import AppModalConfirmStopSolution from "@/modules/solution/components/city/ModalConfirmStopSolution";
import AppModalDeleteSolution from "@/modules/solution/components/city/ModalDelete";
import AppModalConfirmFinishSolution from "@/modules/solution/components/city/ModalConfirmFinishSolution";
import AppModalImportSolution from "@/modules/solution/components/city/ModalImport";
import AppRetrieveSolution from "@/modules/solution/components/city/RetrieveSolution";
import { formatTableValues } from "@/modules/city/components/terms-reference/utils";
import { citySolutionAPI } from "@/modules/city";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AppSolutionList",
  props: {
    filter: { municipioGrupoSolucao: {} },
  },
  components: {
    AppModalInsertSolution,
    AppModalDeleteSolution,
    AppModalConfirmStopSolution,
    AppModalConfirmFinishSolution,
    AppModalImportSolution,
    AppRetrieveSolution,
  },
  data() {
    return {
      headers: [
        {
          text: "Nome",
          align: "left",
          value: "nome",
        },
        {
          text: "Descricao",
          value: "descricao",
        },
        {
          text: "Grupo de Solução",
          value: "municipioGrupoSolucao.nome",
        },
        {
          text: "Consultor",
          value: "usuario.nome",
        },
        {
          text: "Justificativa",
          value: "justificativa",
        },
        { text: "Editar", value: "acoes", sortable: false },
        { text: "Excluir", value: "acoes_delete", sortable: false },
        { text: "Interromper", value: "acoes_interromper", sortable: false },
      ],
      headers_ma: [
        {
          text: "Nome",
          align: "left",
          value: "nome",
        },
        {
          text: "Descricao",
          value: "descricao",
        },
        {
          text: "Grupo de Solução",
          value: "municipioGrupoSolucao.nome",
        },
        {
          text: "Responsável",
          value: "usuario.nome",
        },
        {
          text: "Justificativa",
          value: "justificativa",
        },
        {
          text: "Ações",
          value: "acoes",
          sortable: false,
        },
      ],
      breadcrumbs: [
        {
          text: "Grupos de Soluções",
          disabled: true,
          href: "termo-referencia",
        },
        {
          text: "Soluções",
          disabled: true,
          href: "termo-referencia",
        },
      ],
      modalConfirmFinishSolution: false,
      solutionsToFinish: [],
      municipioSolucaoPT: {
        municipioSolucao: {},
      },
      enabledSolutions: [],
      disabledSolutions: [],
      solutions: [],
      formatTableValues: formatTableValues,
      loading: false,
    };
  },
  computed: {
    ...mapGetters(["isFullAdmin", "isAT"]),
  },

  methods: {
    ...mapActions(["setLoading"]),
    limpar() {
      this.solutions = [];
      this.enabledSolutions = [];
      this.disabledSolutions = [];
    },
    load() {
      var filtros = {
        grupoSolucaoId:
          this.filter.municipioGrupoSolucao &&
          this.filter.municipioGrupoSolucao.municipioGrupoSolucaoId,
        municipioId: this.$route.params.id,
        solucaoId:
          this.filter.municipioSolucao &&
          this.filter.municipioSolucao.municipioSolucaoId,
      };
      this.loading = true;
      this.limpar();
      citySolutionAPI
        .listByCity(filtros)
        .then((resp) => {
          this.solutions = resp.data;

          this.enabledSolutions = resp.data.filter(
            (item) => item.desabilitado === false
          );
          this.disabledSolutions = resp.data.filter(
            (item) => item.desabilitado === true
          );
          this.$emit("solutions", this.solutions);
          this.loading = false;
        })
        .catch((resp) => {
          this.loading = false;
          this.$notification.error(
            `Erro ao listar ${this.isAT ? "iniciativas" : "soluções"}`
          );
        });
    },
    finishSolution(solution) {
      this.solutionsToFinish = [];
      this.solutionsToFinish.push(solution);
      this.modalConfirmFinishSolution = true;
    },
    closeModalFinish() {
      this.modalConfirmFinishSolution = false;
      this.$emit("reloadSolutions");
    },
  },
  mounted() {
    if (this.isAT) {
      this.breadcrumbs = [
        {
          text: "Grupos de Iniciativas",
          disabled: true,
          href: "termo-referencia",
        },
        {
          text: "Iniciativas",
          disabled: true,
          href: "eixo",
        },
      ];

      this.headers = [
        {
          text: "Nome",
          align: "left",
          value: "nome",
        },
        {
          text: "Descricao",
          value: "descricao",
        },
        {
          text: "Grupo de Iniciativa",
          value: "municipioGrupoSolucao.nome",
        },
        {
          text: "ATS",
          value: "usuario.nome",
        },
        {
          text: "Justificativa",
          value: "justificativa",
        },
        { text: "Editar", value: "acoes", sortable: false },
        { text: "Excluir", value: "acoes_delete", sortable: false },
        { text: "Interromper", value: "acoes_interromper", sortable: false },
      ];

      this.headers_ma = [
        {
          text: "Nome",
          align: "left",
          value: "nome",
        },
        {
          text: "Descricao",
          value: "descricao",
        },
        {
          text: "Grupo de Iniciativa",
          value: "municipioGrupoSolucao.nome",
        },
        {
          text: "Responsável",
          value: "usuario.nome",
        },
        {
          text: "Justificativa",
          value: "justificativa",
        },
        {
          text: "Ações",
          value: "acoes",
          sortable: false,
        },
      ];
    }
    if (this.uf === "MA") {
      this.headers = this.headers_ma;
    }
    this.load();
  },
  watch: {
    filter: {
      handler(val, oldVal) {
        console.log("val: ", val);
        this.load();
      },
      deep: true,
    },
    "municipioSolucao.municipioSolucao"(newValue) {
      if (newValue) {
        this.municipioSolucaoPT.municipioSolucao = newValue;
      }
    },
    object(newValue) {
      this.payload = newValue;
    },
  },
};
</script>
